import axios from 'axios/index';
import env from './config/env';

const HELLO_SIGN_PRODUCTION_CLIENT_ID = '3d3134c3e2f7a2534c9b6bc455268b16';
const HELLO_SIGN_STAGING_CLIENT_ID = 'b86ca97ac6834d7f1e2468488efc3d55';
const HELLO_SIGN_LOCAL_DEV_CLIENT_ID = 'b86ca97ac6834d7f1e2468488efc3d55';

let hellosignClientId;

if (env.isProduction()) {
  hellosignClientId = HELLO_SIGN_PRODUCTION_CLIENT_ID;
} else if (env.isLocalDev()) {
  hellosignClientId = HELLO_SIGN_LOCAL_DEV_CLIENT_ID;
} else {
  hellosignClientId = HELLO_SIGN_STAGING_CLIENT_ID;
}

HelloSign.init(hellosignClientId); // eslint-disable-line no-undef

export function getMemberContractUrls(memberId) {
  return axios.post(`${env.backendUrlPrefix}/contracts/members/${memberId}/signatureRequests`).then(response => {
    const contractUrls = response.data;
    return contractUrls;
  });
}

export function openContractIframe(contractUrl, helloSignEventsCallback) {
  const HelloSign = window.HelloSign;
  const document = window.document;
  HelloSign.open({
    // eslint-disable-line no-undef
    skipDomainVerification: !env.isProduction(),
    url: contractUrl,
    uxVersion: 2,
    container: document.getElementById('myHSContainer'),
    messageListener: eventData => {
      if (eventData.event === HelloSign.EVENT_SIGNED) {
        // eslint-disable-line no-undef
        helloSignEventsCallback();
      }
    }
  });
}

export function closeContractIframe() {
  HelloSign.close(); // eslint-disable-line no-undef
}

// export function uploadIdPhoto(memberId, photoFile) {
//   const formData = new FormData();
//   formData.append('image', photoFile, photoFile.name);
//   return axios.post(`${env.backendUrlPrefix}/contracts/members/${memberId}/idPhoto/upload`, formData);
// }



// WEBPACK FOOTER //
// ./src/contractsService.js